import { useI18n } from "../i18n/provider.tsx";
import type { AnswerSource, Confidence } from "../api/domain.ts";
import styles from "./SourceTag.module.scss";

export type SourceTagProps = {
  source: AnswerSource | string;
  confidence?: Confidence | string | null;
};

/**
 * Where an answer came from. AI backfill reads differently on purpose: it loses
 * to human answers in the default precedence, so it must not look equal.
 */
export const SourceTag = (props: SourceTagProps) => {
  const i18n = useI18n();
  const ai = () => props.source === "ai";
  const confidence = () => props.confidence ?? (ai() ? "low" : "high");

  return (
    <span class={`${styles.tag} ${ai() ? styles.ai : styles.human}`}>
      {ai() ? i18n.t().answer.sourceAi : i18n.t().answer.sourceHuman}
      <span class={styles.confidence}>
        {confidence() === "low" ? i18n.t().answer.confidenceLow : i18n.t().answer.confidenceHigh}
      </span>
    </span>
  );
};
